import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import {
  getSagaTopUsersOfEarningsList,
  getSagaTopUsersOfAdvertisingList,
  getSagaTopUsersOfExperienceList,
  getSagaTopUsersOfReferralsList
} from './sagas/getTopUsersListSaga';

export default [
  ...createCombineMapItem('topUsersOfEarningsList', createListReduceObject, [
    getSagaTopUsersOfEarningsList
  ]),
  ...createCombineMapItem('topUsersOfAdvertisingList', createListReduceObject, [
    getSagaTopUsersOfAdvertisingList
  ]),
  ...createCombineMapItem('topUsersOfExperienceList', createListReduceObject, [
    getSagaTopUsersOfExperienceList
  ]),
  ...createCombineMapItem('topUsersOfReferralsList', createListReduceObject, [
    getSagaTopUsersOfReferralsList
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/topUsers/reducers/static/lists/reducersMap.js